import { createStore } from 'owa-satcheljs';
import type Win32StyleStoreSchema from './schema/Win32StyleStoreState';

const getWin32StyleStore: () => Win32StyleStoreSchema = createStore<Win32StyleStoreSchema>(
    'win32StyleThemeStore',
    {
        isEnabled: false,
        isEnabledPreview: false,
        win32StyleThemeId: undefined,
        nonWin32StyleThemeId: undefined,
    }
);

export default getWin32StyleStore;
